import React from 'react';

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#AC885B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 18L17.94 6M18 18L6.06 6"
      ></path>
    </svg>
  );
}

export default CloseIcon;
